import { useState } from "react";
import { apiFetch } from "../../../context/AuthContext";
import { API_URL } from "../config";

// Unique companies list for the current client (used by the company filter)
export const useCompanies = ({ profile }) => {
  const [companies, setCompanies] = useState([]);

  // Function to fetch unique companies for the current client
  const fetchCompanies = async () => {
    try {
      const clientName = profile?.clientName || localStorage.getItem("clientName");

      let response;

      if (clientName && clientName.toLowerCase() !== "infinity") {
        // Fetch employees for specific client
        response = await apiFetch(`${API_URL}/employees/clients/${clientName}`, { method: "GET" });
      } else {
        // Fetch all employees
        response = await apiFetch(`${API_URL}/employees`, { method: "GET" });
      }
      const employeesData = await response.json();
      const list = employeesData.employees || employeesData;

      // Extract unique companies from workingCompany field
      const uniqueCompanies = [...new Set(
        list
          .map(emp => emp.workingCompany)
          .filter(company => company && company.trim() !== "")
      )].sort();

      setCompanies(uniqueCompanies);
      console.log(`✅ Found ${uniqueCompanies.length} unique companies`);
    } catch (err) {
      console.error("❌ Failed to fetch companies:", err);
    }
  };

  return { companies, fetchCompanies };
};
